import { PageWrapper } from 'src/components/PageWrapper';
import { ErrorInfo } from 'src/pages/teams/_components/AuthErrorView/ErrorInfo';

import { IllustrationError500 } from '@/components/Illustration';

interface ZoomFatalErrorProps {
  description?: string;
}

// Shown instead of a blank screen or an indefinite spinner — both an
// unrecoverable render error (via ZoomErrorBoundary) and a hung/rejected
// zoomSdk.config() (via page.tsx) land here with a reload affordance.
export const ZoomFatalError = ({
  description = 'Meeting analysis ran into a problem while loading. Please reload the app.',
}: ZoomFatalErrorProps) => {
  return (
    <PageWrapper>
      <div className="flex flex-1 flex-col items-center justify-center gap-12">
        <ErrorInfo
          closeLabel="Reload"
          description={description}
          title="Something went wrong"
          onClose={() => window.location.reload()}
        >
          <IllustrationError500 className="max-w-480" />
        </ErrorInfo>
      </div>
    </PageWrapper>
  );
};
